// Lot 728 — un message rafraîchi par le sondage / la reconnexion est-il IDENTIQUE à celui déjà affiché ?
// Si oui, on garde l'objet existant : la bulle mémoïsée (React.memo) n'est pas re-rendue.
const FIELDS = ["content", "is_deleted", "edited", "starred", "media_url", "media_type", "delivered_at", "forwarded", "created_at", "sender_id"];

const sameJson = (a, b) => (a === b) || JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

export const sameMessage = (a, b) => {
  if (!a || !b || a.id !== b.id) return false;
  for (const f of FIELDS) if ((a[f] ?? null) !== (b[f] ?? null)) return false;
  return sameJson(a.reactions, b.reactions) && sameJson(a.media_group, b.media_group) && sameJson(a.reply_to, b.reply_to)
    && sameJson(a.ref, b.ref) && sameJson(a.cta, b.cta);
};
